/* Pooja Ragenee buy page (sections/pr-buy.liquid). Port of the mockup AP.buy.mount, driven by Liquid data:
   [data-pr-product] blob (snippets/pr-variant-data.liquid) + [data-pr-buy-msg] copy.
   Colour -> Size (sold-out greyed, "Only N left"), gallery per colour set, summary + Add to bag through the real
   product form (input name=id kept in sync, ?variant= in the URL), PR.bag.add, size helper picks, sticky bar.
   Owns PR.buy only. */
(function (w, d) {
  'use strict';
  var PR = w.PR;
  if (!PR || !PR.sections) return;

  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function esc(s) {
    return PR.esc ? PR.esc(s) : String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(p) { return PR.money ? PR.money(p) : '₹' + Math.round((Number(p) || 0) / 100).toLocaleString('en-IN'); }
  function parse(el) { if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  function fill(t, map) { return String(t || '').replace(/\[(\w+)\]/g, function (m, k) { return map[k] != null ? map[k] : m; }); }
  function reduced() { return PR.reduced ? PR.reduced() : false; }
  function label(c) { return c && PR.colour && PR.colour.label ? PR.colour.label(c) : (c || ''); }
  function swatch(c) { return PR.colour && PR.colour.bg ? PR.colour.bg(c) : '#ccc'; }
  function icon(n) { return PR.icon ? PR.icon(n) : ''; }
  function cssq(s) { return w.CSS && CSS.escape ? CSS.escape(s) : String(s).replace(/"/g, '\\"'); }
  function at(src, width) { return /[?&]width=\d+/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=' + width) : src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=' + width; }

  var live = [];
  var KWIK = '.gokwik-buynow-button, #gokwik-buy-now, [class*="gokwik-buy"]';

  function init(el) {
    var P = parse($('[data-pr-product]', el)), M = parse($('[data-pr-buy-msg]', el)) || {};
    if (!P || !P.variants || !P.variants.length) return;
    var cfg = PR.cfg || {}, low = cfg.lowStock || 3, freeFrom = cfg.freeShipFrom || 49900;
    var ci = P.colourIndex ? P.colourIndex - 1 : -1, si = P.sizeIndex ? P.sizeIndex - 1 : -1;
    var cbg = {};
    (P.colours || []).forEach(function (c) { cbg[c.name] = c.bg || swatch(c.name); });
    var cList = (P.colours || []).length ? P.colours.map(function (c) { return c.name; }) : [''];
    var sList = (P.sizes || []).length ? P.sizes.slice() : [''];
    var V = {};
    P.variants.forEach(function (v) { V[(si >= 0 ? v.options[si] : '') + '|' + (ci >= 0 ? v.options[ci] : '')] = v; });
    function variant(s, c) { return V[(s || '') + '|' + (c || '')] || null; }
    function vstate(s, c) {
      var v = variant(s, c);
      if (!v || !v.available) return 'out';
      return v.qty != null && v.qty > 0 && v.qty <= low ? 'low' : 'in';
    }
    function buyable(s, c) { return vstate(s, c) !== 'out'; }
    function nBuy(c) { return sList.filter(function (s) { return buyable(s, c); }).length; }
    function sizeLabel(s) { s = String(s || ''); if (/^free/i.test(s)) return M.freeSize || s; var u = s.toUpperCase().trim(); return u === 'XXL' ? '2XL' : u === 'XXXL' ? '3XL' : s; }
    var hasSize = si >= 0 && sList[0] !== '', hasColour = ci >= 0 && cList[0] !== '';
    var oneSize = sList.length === 1;
    var anyBuyable = cList.some(function (c) { return nBuy(c) > 0; });
    var cartTotal = P.cartTotal || 0;

    var st = { color: cList.reduce(function (b, c) { return nBuy(c) > nBuy(b) ? c : b; }, cList[0]), size: null, note: '', img: 0, gkey: '' };
    if (P.selected) {
      var sv = P.variants.filter(function (v) { return v.id === P.selected; })[0];
      if (sv) { if (ci >= 0) st.color = sv.options[ci]; if (sv.available) st.size = si >= 0 ? sv.options[si] : ''; }
    }
    if (st.size === null && oneSize && buyable(sList[0], st.color)) st.size = sList[0];

    var C = $('[data-b-colors]', el), S = $('[data-b-sizes]', el), gal = $('[data-b-gal]', el);
    var form = $('form.pb-form', el) || $('form[action*="/cart/add"]', el);
    var idInput = form ? $('input[name="id"][data-b-id]', form) || $('input[name="id"]', form) : null;
    var addBtn = $('[data-b-add]', el), bar = $('[data-b-bar]', el), busy = false;
    var thumb = $('[data-b-thumb] img', el);

    /* gallery: the colour's photo set (starts at its variant photo, the first set at 0, ends at the next colour's) */
    function group(c) {
      var n = (P.images || []).length, all = [], i;
      for (i = 0; i < Math.min(n, 10); i++) all.push(i);
      all = lead(all);
      if (!hasColour || n < 2) return all;
      var s = null, min = n, e = n;
      P.variants.forEach(function (v) {
        if (v.image == null) return;
        if (v.image < min) min = v.image;
        if (v.options[ci] === c && (s === null || v.image < s)) s = v.image;
      });
      if (s === null) return all;
      P.variants.forEach(function (v) { if (v.image != null && v.options[ci] !== c && v.image > s && v.image < e) e = v.image; });
      if (s === min) s = 0;
      if (e <= s) return all;
      var out = [];
      for (i = s; i < e && out.length < 10; i++) out.push(i);
      return lead(out);
    }
    /* pr-meta photo order (mockup cfg.photoOrder): those photos lead the set that starts at photo 1 */
    function lead(g) {
      var o = P.order || [];
      if (!o.length || g[0] !== 0) return g;
      var f = o.filter(function (k) { return g.indexOf(k) >= 0; });
      return f.concat(g.filter(function (k) { return f.indexOf(k) < 0; }));
    }
    function imgTag(im, k, total, extra) {
      var ws = [480, 720, 960, 1200, 1500].filter(function (x) { return x <= (im.w || 1500); });
      if (!ws.length) ws = [im.w || 480];
      var alt = fill(M.photo || '', { name: P.name }).replace('7771', k + 1).replace('7772', total);
      return '<img src="' + esc(at(im.src, 1200)) + '" srcset="' + esc(ws.map(function (x) { return at(im.src, x) + ' ' + x + 'w'; }).join(', ')) + '"' +
        ' sizes="(min-width: 1069px) 52vw, 100vw" alt="' + esc(alt) + '" width="' + (im.w || 1200) + '" height="' + (im.h || 1200) + '"' + (extra || '') + '>';
    }
    function buildGallery(force) {
      if (!gal) return;
      var g = group(st.color), key = g.join(',');
      if (!force && key === st.gkey) return;
      var first = st.gkey === '';
      st.gkey = key; st.img = 0;
      if (first && gal.getAttribute('data-b-key') === (g.length ? g[0] + '-' + g.length : '0-0')) { wireShots(); return; }   // Liquid already rendered this set
      var n = g.length, ims = P.images;
      var html = '<div class="ap-bgal__stage" tabindex="0" role="region" aria-roledescription="carousel" aria-label="' + esc(P.name) + '">' +
        g.map(function (ix, k) { return imgTag(ims[ix], k, n, k ? ' loading="lazy" aria-hidden="true"' : ' class="is-on" fetchpriority="high"'); }).join('') +
        (n > 1 ? '<button type="button" class="ap-icon-btn ap-bgal__arrow ap-bgal__arrow--prev" data-b-go="-1" aria-label="' + esc(M.prev || '') + '">' + icon('chevron-left') + '</button>' +
                 '<button type="button" class="ap-icon-btn ap-bgal__arrow ap-bgal__arrow--next" data-b-go="1" aria-label="' + esc(M.next || '') + '">' + icon('chevron-right') + '</button>' : '') +
        '</div>';
      if (n > 1) {
        var lab = function (k) { return fill(M.photo || '', { name: P.name }).replace('7771', k + 1).replace('7772', n); };
        html += '<div class="ap-bgal__dots" role="group" aria-label="' + esc(P.name) + '">' + g.map(function (ix, k) { return '<button type="button" data-b-dot="' + k + '" aria-label="' + esc(lab(k)) + '" aria-current="' + (k === 0) + '"></button>'; }).join('') + '</div>' +
          '<div class="ap-bgal__thumbs" role="group" aria-label="' + esc(P.name) + '">' + g.map(function (ix, k) {
            var im = ims[ix];
            return '<button type="button" data-b-dot="' + k + '" aria-label="' + esc(lab(k)) + '" aria-current="' + (k === 0) + '"><img src="' + esc(at(im.src, 144)) + '" alt="" width="72" height="72" loading="lazy"></button>';
          }).join('') + '</div>';
      }
      gal.innerHTML = html;
      wireShots();
      if (thumb && ims[g[0]]) { thumb.src = at(ims[g[0]].src, 160); thumb.removeAttribute('srcset'); }
    }
    function wireShots() {
      $$('.ap-bgal__stage img', gal).forEach(function (im, k) { if (k) im.setAttribute('aria-hidden', 'true'); });
    }
    function show(i) {
      var shots = $$('.ap-bgal__stage img', gal), n = shots.length;
      if (n < 2) return;
      i = (i + n) % n; st.img = i;
      shots.forEach(function (im, k) {
        im.classList.toggle('is-on', k === i);
        if (k === i) { im.removeAttribute('aria-hidden'); im.loading = 'eager'; } else im.setAttribute('aria-hidden', 'true');
      });
      $$('[data-b-dot]', gal).forEach(function (b) { b.setAttribute('aria-current', String(+b.getAttribute('data-b-dot') === i)); });
    }
    var sx = null, sy = 0;
    function onGalClick(e) {
      var dot = e.target.closest('[data-b-dot]'); if (dot) { show(+dot.getAttribute('data-b-dot')); return; }
      var go = e.target.closest('[data-b-go]'); if (go) show(st.img + +go.getAttribute('data-b-go'));
    }
    function onDown(e) { if (e.target.closest('button') || !e.target.closest('.ap-bgal__stage')) return; sx = e.clientX; sy = e.clientY; }
    function onUp(e) {
      if (sx == null) return;
      var dx = e.clientX - sx, dy = e.clientY - sy; sx = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(st.img + (dx < 0 ? 1 : -1));
    }
    function onKey(e) {
      if (!e.target.closest('.ap-bgal__stage')) return;
      if (e.key === 'ArrowRight') show(st.img + 1); else if (e.key === 'ArrowLeft') show(st.img - 1);
    }
    if (gal) {
      gal.addEventListener('click', onGalClick);
      gal.addEventListener('pointerdown', onDown);
      gal.addEventListener('pointerup', onUp);
      gal.addEventListener('pointercancel', function () { sx = null; });
      gal.addEventListener('keydown', onKey);
    }

    /* steps */
    function swatchesHTML() {
      return cList.map(function (c) {
        var ok = st.size !== null && hasSize ? buyable(st.size, c) : nBuy(c) > 0;
        var lab = label(c) + (ok ? '' : ', ' + (st.size !== null && hasSize ? (M.soldOut || '') + ' (' + sizeLabel(st.size) + ')' : (M.soldOut || '')));
        return '<button type="button" class="ap-swatch" data-color="' + esc(c) + '" data-state="' + (ok ? 'in' : 'out') + '" style="--sw:' + esc(cbg[c] || swatch(c)) + '" aria-pressed="' + (st.color === c) + '" aria-label="' + esc(lab) + '" title="' + esc(lab) + '"></button>';
      }).join('');
    }
    function sizesHTML() {
      return sList.map(function (s) {
        var state = vstate(s, st.color), out = state === 'out', v = variant(s, st.color);
        var note = out ? (M.soldOut || '') : state === 'low' ? String(M.onlyLeft || '').replace('7777', v.qty) : '';
        var lab = sizeLabel(s);
        return '<button type="button" class="ap-size" data-size="' + esc(s) + '" data-state="' + state + '" aria-pressed="' + (st.size === s) + '"' + (out ? ' disabled' : '') + ' aria-label="' + esc(lab + (note ? ', ' + note : '')) + '">' +
          '<span class="ap-size__label">' + esc(lab) + '</span>' + (note ? '<span class="ap-size__note">' + esc(note) + '</span>' : '') + '</button>';
      }).join('');
    }
    function pickText(withChoose) {
      var parts = [];
      if (hasColour) parts.push(label(st.color));
      if (hasSize) { if (st.size !== null) parts.push(sizeLabel(st.size)); else if (withChoose) parts.push(M.chooseSize || ''); }
      return parts.filter(Boolean).join(' · ');
    }
    function current() { return st.size !== null ? variant(hasSize ? st.size : '', st.color) : null; }

    function render() {
      if (C) C.innerHTML = swatchesHTML();
      if (S) S.innerHTML = sizesHTML();
      var cn = $('[data-b-cname]', el); if (cn) cn.textContent = label(st.color);
      buildGallery(false);
      var v = current(), unit = v ? v.price : P.price;
      var mrp = v ? (v.compare_at > v.price ? v.compare_at : 0) : (P.compare_at > P.price ? P.compare_at : 0);
      var priceText = v || !(P.priceMax > P.price) ? money(unit) : fill(M.from || '[price]', { price: money(unit) });
      var priceHTML = esc(priceText) + (mrp > unit ? ' <s class="ap-mrp"><span class="ap-sr">' + esc(M.mrp || 'MRP') + ' </span>' + esc(money(mrp)) + '</s>' : '');
      var pr = $('[data-b-price]', el); if (pr) pr.innerHTML = priceHTML;
      var pk = $('[data-b-pick]', el); if (pk) pk.textContent = pickText(false);
      var ok = !!(v && v.available);
      if (addBtn) addBtn.disabled = !ok || busy;
      var note = st.note;
      if (!note) {
        if (!anyBuyable) note = M.sold || '';
        else if (!ok) note = M.choose || '';
        else {
          var gap = freeFrom - (cartTotal + unit);
          note = gap <= 0 ? (M.free || '') : fill(M.gap || '', { amount: money(gap) });
        }
      }
      var nt = $('[data-b-note]', el); if (nt) nt.textContent = note;
      /* input name=id holds a variant only while a buyable colour + size is chosen: buy-now apps (Kwik) read it */
      if (idInput) idInput.value = ok ? v.id : '';
      el.classList.toggle('pb-buy-wait', !ok);
      $$('[data-pr-app]', el).forEach(function (a) {
        var k = $(KWIK, a); if (!k) return;
        a.hidden = !anyBuyable;
        k.setAttribute('aria-disabled', String(!ok));
      });
      if (v && ok && v.id !== st.vid) {
        st.vid = v.id;
        try { var u = new URL(w.location.href); u.searchParams.set('variant', v.id); w.history.replaceState(w.history.state, '', u.toString()); } catch (e) {}
        try { d.dispatchEvent(new CustomEvent('pr:variant', { detail: { variant: v, product: P.handle } })); } catch (e) {}
      }
      if (bar) {
        $('[data-bar-price]', bar).innerHTML = priceHTML;
        $('[data-bar-pick]', bar).textContent = pickText(true);
        var bb = $('[data-bar-add]', bar);
        bb.textContent = ok ? (M.add || '') : anyBuyable ? (M.chooseSize || '') : (M.soldOut || '');
        bb.disabled = !anyBuyable || busy;
        bb.classList.toggle('is-pending', !ok && anyBuyable);
        var dot = $('[data-bar-dot]', bar);
        if (dot) { dot.hidden = !hasColour; dot.style.setProperty('--sw', cbg[st.color] || swatch(st.color)); }
      }
    }

    function onColour(e) {
      var b = e.target.closest('[data-color]'); if (!b) return;
      st.color = b.getAttribute('data-color'); st.note = '';
      if (st.size !== null && hasSize && !buyable(st.size, st.color)) {
        st.note = fill(M.sizeOut || '', { size: sizeLabel(st.size), colour: label(st.color) }); st.size = null;
      } else if (oneSize && buyable(sList[0], st.color)) st.size = sList[0];
      render();
      var nb = $('[data-color="' + cssq(st.color) + '"]', C); if (nb) nb.focus({ preventScroll: true });
    }
    function onSize(e) {
      var b = e.target.closest('[data-size]'); if (!b || b.disabled) return;
      st.size = b.getAttribute('data-size'); st.note = ''; render();
      var nb = $('[data-size="' + cssq(st.size) + '"]', S); if (nb) nb.focus({ preventScroll: true });
    }
    if (C) C.addEventListener('click', onColour);
    if (S) S.addEventListener('click', onSize);

    function flashSize() {
      var sec = $('[data-b-size-step]', el); if (!sec) return;
      sec.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'center' });
      sec.classList.remove('is-flash'); void sec.offsetWidth; sec.classList.add('is-flash');
    }
    function add() {
      var v = current();
      if (!v || !v.available || busy) return false;
      var qtyEl = form ? $('input[name="quantity"]', form) : null, q = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
      if (!PR.bag || !PR.bag.add) { if (form) { if (idInput) idInput.value = v.id; form.submit(); } return true; }
      busy = true; render();
      PR.bag.add({ id: v.id, quantity: q }).then(function (cart) {
        if (cart && cart.total_price != null) cartTotal = cart.total_price;
        st.note = M.added || '';
      }, function () { /* pr-bag shows the toast */ }).then(function () { busy = false; render(); });
      return true;
    }
    function onSubmit(e) { e.preventDefault(); if (!add() && anyBuyable) flashSize(); }
    if (form) form.addEventListener('submit', onSubmit);
    /* buy-now app buttons (capture phase, before their inline onclick): only with a buyable colour + size */
    function onAppClick(e) {
      if (!e.target.closest || !e.target.closest(KWIK) || !e.target.closest('[data-pr-app]')) return;
      var v = current();
      if (v && v.available) { if (idInput) idInput.value = v.id; return; }
      e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      if (anyBuyable) { st.note = M.choose || ''; render(); flashSize(); }
    }
    el.addEventListener('click', onAppClick, true);
    if (bar) $('[data-bar-add]', bar).addEventListener('click', function () { if (!add()) flashSize(); });

    /* size helper (pr-size.js) "Choose 36D" */
    function pick(size) {
      if (!hasSize || sList.indexOf(size) < 0) return;
      if (buyable(size, st.color)) { st.size = size; st.note = ''; }
      else {
        var alt = cList.filter(function (c) { return buyable(size, c); })[0];
        if (alt) { st.note = fill(M.switched || '', { size: sizeLabel(size), colour: label(st.color), alt: label(alt) }); st.color = alt; st.size = size; }
        else { st.note = fill(M.allOut || '', { size: sizeLabel(size) }); st.size = null; }
      }
      render();
      var sb = $('[data-size="' + cssq(size) + '"]', S); if (sb && !sb.disabled) sb.focus({ preventScroll: true });
    }
    function onPick(e) { var s = e.detail && (e.detail.size || e.detail); if (typeof s === 'string') pick(s); }
    function onCart(e) {
      var cart = e.detail && (e.detail.cart || e.detail);
      if (cart && cart.total_price != null) cartTotal = cart.total_price;
      if (!st.note || st.note === M.added) render();
    }
    d.addEventListener('pr:size-pick', onPick);
    d.addEventListener('pr:cart', onCart);

    /* sticky bar: shows once the summary's own button is off screen (phones/tablets only) */
    var sumVisible = true, tk = false, io = null;
    function tick() {
      if (tk || !bar) return; tk = true;
      w.requestAnimationFrame(function () {
        tk = false;
        var on = w.innerWidth < 1069 && (w.scrollY || 0) > 160 && !sumVisible && anyBuyable;
        if (bar.classList.contains('is-on') !== on) { bar.classList.toggle('is-on', on); bar.inert = !on; }
      });
    }
    if (bar) {
      d.body.classList.add('ap-has-buybar');
      if ('IntersectionObserver' in w && addBtn) { io = new IntersectionObserver(function (es) { sumVisible = es[0].isIntersecting; tick(); }); io.observe(addBtn); }
      else sumVisible = false;
      w.addEventListener('scroll', tick, { passive: true });
      w.addEventListener('resize', tick);
    }

    render();
    tick();

    var api = { el: el, product: P, state: st, render: render, pick: pick, show: show };
    el._prBuy = api;
    live.push({ el: el, off: function () {
      d.removeEventListener('pr:size-pick', onPick);
      d.removeEventListener('pr:cart', onCart);
      w.removeEventListener('scroll', tick);
      w.removeEventListener('resize', tick);
      if (io) io.disconnect();
      if (bar) d.body.classList.remove('ap-has-buybar');
    } });
  }

  function destroy(el) {
    live = live.filter(function (x) { if (x.el === el) { x.off(); return false; } return true; });
    el._prBuy = null;
  }

  PR.buy = { get: function (el) { return (el || $('[data-pr-section="pr-buy"]') || {})._prBuy || null; } };
  PR.sections.register('pr-buy', init, destroy);
})(window, document);